import React, { FC, useEffect, useState } from 'react';
import Modal from 'components/UI_kit_3/Modal/Modal';
import { useAppSelector, useUserThunkDispatch } from 'hooks';
import { Trans, useTranslation } from 'react-i18next';
import Button from 'components/UI_kit_3/Button/Button';
import useAsyncFetch from 'hooks/async-fetch';
import profileService from 'services/api/customer/profile-service';
import { userActions } from 'store/user';
import { useNavigate } from 'react-router-dom';

const TwoFAEnforcementModal: FC = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.user);
  const dispatch = useUserThunkDispatch();
  const [show, setShow] = useState(false);

  const [handleSkip, skipLoading] = useAsyncFetch({
    async asyncFunc() {
      await profileService.postpone2FAEnforcement();
      setShow(false);
      dispatch(userActions.fetchProfile());
    },
    errorNote: true,
  });

  const handleGoToSettings = () => {
    dispatch(userActions.setTwoFAEnforcement({ ...user.twoFaEnforcement, remindNow: false }));
    navigate('/settings/two-fa');
  };

  useEffect(() => {
    if (user.twoFaEnforcement?.remindNow) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [user.twoFaEnforcement]);

  return (
    <Modal show={show} onHide={() => setShow(false)} disableBackdropClose>
      <Modal.Header>
        {t('two_fa.self')}
      </Modal.Header>
      <Modal.Body className="text-pre-line">
        <Trans
          i18nKey="two_fa.enforce_warning"
          values={{
            deadline: user.twoFaEnforcement?.deadline,
          }}
          components={{
            strong: <strong />,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        {!user.twoFaEnforcement?.blocking && (
          <Button variant="secondary" onClick={handleSkip} disabled={skipLoading}>
            {t('common.skip')}
          </Button>
        )}
        <Button onClick={handleGoToSettings}>
          {t('two_fa.go_to_settings')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TwoFAEnforcementModal;
